import { render, staticRenderFns } from "./ManualEnrolment.vue?vue&type=template&id=086c2245"
import script from "./ManualEnrolment.vue?vue&type=script&lang=js"
export * from "./ManualEnrolment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports